import {ChevronDownIcon, ChevronRightIcon, ToolsIcon} from '@primer/octicons-react'
import {Details, useDetails} from '@primer/react'

import type {ThirdPartyMcpToolResultReference} from '../utils/copilot-chat-types'
import styles from './ChatMessageMcpToolResultsList.module.css'

export interface ChatMessageMcpToolResultsListProps {
  mcpToolResults: ThirdPartyMcpToolResultReference[]
}

export function ChatMessageMcpToolResultsList({mcpToolResults}: ChatMessageMcpToolResultsListProps) {
  if (!mcpToolResults || mcpToolResults.length === 0) {
    return null
  }

  return (
    <div className="mb-2">
      {mcpToolResults.map(result => (
        <McpToolResult key={result.toolName} result={result} />
      ))}
    </div>
  )
}

function McpToolResult({result}: {result: ThirdPartyMcpToolResultReference}) {
  const {getDetailsProps, open} = useDetails({})

  return (
    <Details key={result.toolName} className={styles.Details} {...getDetailsProps()}>
      <summary>
        {!open && <ChevronRightIcon size={16} className="mr-1 inline-block" />}
        {open && <ChevronDownIcon size={16} className="mr-1 inline-block" />}
        <ToolsIcon size={16} className="mr-1 inline-block" />
        Called {result.toolName} from {result.serverName}
      </summary>
      <h3 className={styles.ToolInputOutputHeading}>Input</h3>
      <div className="border rounded p-2 mb-2">
        <span className={styles.ToolInputOutputContents}>{JSON.stringify(result.toolArguments, null, 2)}</span>
      </div>

      <h3 className={styles.ToolInputOutputHeading}>Output</h3>
      <div className="border rounded p-2 mb-2">
        <span className={styles.ToolInputOutputContents}>{JSON.stringify(result.toolResponse, null, 2)}</span>
      </div>
    </Details>
  )
}

try{ ChatMessageMcpToolResultsList.displayName ||= 'ChatMessageMcpToolResultsList' } catch {}
try{ McpToolResult.displayName ||= 'McpToolResult' } catch {}